module.exports = __webpack_public_path__ + "static/media/Sport_main_preview.fba3a382.jpg";